import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'team',
  templateUrl: './team.component.html',
  styleUrls: ['./team.component.sass']
})
export class TeamComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }
}
